import { Dropdown, DropdownRef } from "antd-mobile";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { getText } from "../../../../utils/util";
import "./index.css";

export default function PageRegister({
  doRegister,
  areas,
  sendSMS,
  show60,
  setShow60,
  companyData,
  registerMsg,
}) {
  const navigate = useNavigate();
  const { code } = useParams();
  const { t: translate } = useTranslation();
  const [isPhone, setIsPhone] = useState(false);
  const [area, setArea] = useState({} as any);
  const [passwordType1, setPasswordType1] = useState(true);
  const [passwordType2, setPasswordType2] = useState(true);
  const [passwordType3, setPasswordType3] = useState(true);
  const [passwordType4, setPasswordType4] = useState(true);
  const dropdownRef = useRef<DropdownRef>();
  const [time, setTime] = useState(60);
  const lan = localStorage.getItem("i18n");
  const appStatus = localStorage.getItem("appStatus");
  const inviteType = localStorage.getItem("inviteType");
  let timeTemp = 60;
  let timer;

  //发送数据
  const [sendData, setSendData] = useState({
    type: 2,
    username: "",
    password: "",
    repassword: "",
    regcode: "",
    invit: "",
    area: areas[0],
  });
  //切换选项
  const changeType = (type: number) => {
    setSendData({
      type: type,
      username: "",
      password: "",
      repassword: "",
      regcode: "",
      invit: code || "",
      area: areas[0],
    });
  };

  //修改数据
  const updateSendData = (e) => {
    const name = e.target.name;
    setSendData({
      ...sendData,
      [name]: e.target.value,
    });
  };

  useEffect(() => {
    setArea(areas[0]);
  }, [areas]);

  useEffect(() => {
    if (code) {
      setSendData((prev) => ({
        ...prev,
        invit: code,
      }));
    }
  }, [code]);

  useEffect(() => {
    if (show60) {
      timer = setInterval(() => {
        if (timeTemp <= 1) {
          timeTemp = 60;
        }
        timeTemp = timeTemp - 1;
        setTime(timeTemp);
        if (timeTemp === 1) {
          setShow60(false);
          clearInterval(timer);
        }
      }, 1000);
    }

    return () => {
      // clearInterval(timer);
      // setShow60(false);
    };
  }, [show60]);

  return (
    <div className="flex-1 flex flex-col items-center py-6 px-4">
      <div className="w-full max-w-md mx-auto">
        <div className="mb-8">
          {/* Tab Switcher */}
          <div className="flex justify-center mb-6">
            <div
              className={`px-4 py-2 rounded-l-lg ${
                !isPhone
                  ? "bg-primary text-black"
                  : "bg-neutral-800 text-neutral-400"
              } cursor-pointer transition-colors duration-200 text-center text-sm w-32`}
              onClick={() => {
                setIsPhone(false);
                setPasswordType1(true);
                setPasswordType2(true);
                setPasswordType3(true);
                setPasswordType4(true);
                changeType(2);
              }}
            >
              {translate(getText("郵箱註冊"))}
            </div>
            <div
              className={`px-4 py-2 rounded-r-lg ${
                isPhone
                  ? "bg-primary text-black"
                  : "bg-neutral-800 text-neutral-400"
              } cursor-pointer transition-colors duration-200 text-center text-sm w-32`}
              onClick={() => {
                setIsPhone(true);
                setPasswordType1(true);
                setPasswordType2(true);
                setPasswordType3(true);
                setPasswordType4(true);
                changeType(1);
              }}
            >
              {translate(getText("手機註冊"))}
            </div>
          </div>

          {/* Help button */}
          <div
            className="absolute top-4 right-4 cursor-pointer"
            onClick={() => {
              navigate("/chatcenter");
            }}
          >
            <img src="/img/kf.png" className="w-6 h-6" />
          </div>

          {/* Email Registration Form */}
          {!isPhone && (
            <div className="w-full space-y-4">
              <div className="relative">
                <input
                  type="text"
                  name="username"
                  value={sendData.username}
                  placeholder={translate(getText("請輸入您的電子郵件"))}
                  onChange={updateSendData}
                  className="w-full bg-neutral-800 border border-neutral-700 rounded-lg px-4 py-3 text-sm text-white focus:outline-none focus:border-primary"
                />
              </div>

              <div className="flex space-x-2">
                <input
                  type="text"
                  name="regcode"
                  value={sendData.regcode}
                  placeholder={translate(getText("請輸入驗證碼"))}
                  onChange={updateSendData}
                  className="flex-1 bg-neutral-800 border border-neutral-700 rounded-lg px-4 py-3 text-sm text-white focus:outline-none focus:border-primary"
                />
                <button
                  className={`w-32 py-3 rounded-lg text-xs ${
                    show60
                      ? "bg-neutral-700 text-neutral-400"
                      : "bg-primary text-black"
                  }`}
                  onClick={() => {
                    if (show60) {
                      return;
                    }
                    const data = { ...sendData };
                    data.area = area?.internationalAreaCode;
                    sendSMS(data);
                  }}
                >
                  {!show60 && translate(getText("發送驗證碼"))}
                  {show60 && `${time}s`}
                </button>
              </div>

              <div className="relative">
                <input
                  type={passwordType1 ? "password" : "text"}
                  name="password"
                  value={sendData.password}
                  placeholder={translate(getText("請輸入密碼"))}
                  onChange={updateSendData}
                  className="w-full bg-neutral-800 border border-neutral-700 rounded-lg px-4 py-3 text-sm text-white focus:outline-none focus:border-primary"
                />
                <div
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                  onClick={() => {
                    setPasswordType1(!passwordType1);
                  }}
                >
                  <img
                    src={
                      passwordType1
                        ? "/img/login_btn_eye_close.png"
                        : "/img/login_btn_eye_open.png"
                    }
                    className="w-5 h-5"
                  />
                </div>
              </div>

              <div className="relative">
                <input
                  type={passwordType2 ? "password" : "text"}
                  name="repassword"
                  value={sendData.repassword}
                  placeholder={translate(getText("請輸入密碼"))}
                  onChange={updateSendData}
                  className="w-full bg-neutral-800 border border-neutral-700 rounded-lg px-4 py-3 text-sm text-white focus:outline-none focus:border-primary"
                />
                <div
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                  onClick={() => {
                    setPasswordType2(!passwordType2);
                  }}
                >
                  <img
                    src={
                      passwordType2
                        ? "/img/login_btn_eye_close.png"
                        : "/img/login_btn_eye_open.png"
                    }
                    className="w-5 h-5"
                  />
                </div>
              </div>

              {inviteType == "1" && (
                <div className="relative">
                  <input
                    type="text"
                    name="invit"
                    value={sendData.invit}
                    placeholder={translate(getText("請輸入邀請碼"))}
                    onChange={updateSendData}
                    className="w-full bg-neutral-800 border border-neutral-700 rounded-lg px-4 py-3 text-sm text-white focus:outline-none focus:border-primary"
                  />
                </div>
              )}
            </div>
          )}

          {/* Phone Registration Form */}
          {isPhone && (
            <div className="w-full space-y-4">
              <div className="flex">
                <div className="w-24 mr-2">
                  <Dropdown
                    ref={dropdownRef}
                    closeOnClickAway={true}
                    className="h-12 bg-transparent"
                  >
                    <Dropdown.Item
                      key="sorter"
                      title={`+ ${area && area?.internationalAreaCode}`}
                      className="revert-style bg-neutral-800 border border-neutral-700 rounded-lg px-2 py-3 text-sm h-12"
                    >
                      <div className="h-64 overflow-y-auto text-neutral-200  bg-neutral-900 p-2">
                        {areas.map((data) => (
                          <div
                            key={data.id}
                            onClick={() => {
                              setArea(data);
                              dropdownRef.current?.close();
                            }}
                            className="py-3 px-4 flex justify-between items-center cursor-pointer hover:bg-neutral-700 border-b"
                          >
                            {localStorage.getItem("i18n") == "zh"
                              ? data.nameZh
                              : data.nameEn}
                            <span className="float-right">
                              +{data.internationalAreaCode}
                            </span>
                            {/* <Divider className="my-1 bg-neutral-700" /> */}
                          </div>
                        ))}
                      </div>
                    </Dropdown.Item>
                  </Dropdown>
                </div>
                <input
                  type="text"
                  name="username"
                  value={sendData.username}
                  placeholder={translate(getText("請輸入電話號碼"))}
                  onChange={updateSendData}
                  className="flex-1 bg-neutral-800 border border-neutral-700 rounded-lg px-4 py-3 text-sm text-white focus:outline-none focus:border-primary"
                />
              </div>

              <div className="flex space-x-2">
                <input
                  type="text"
                  name="regcode"
                  value={sendData.regcode}
                  placeholder={translate(getText("請輸入驗證碼"))}
                  onChange={updateSendData}
                  className="flex-1 bg-neutral-800 border border-neutral-700 rounded-lg px-4 py-3 text-sm text-white focus:outline-none focus:border-primary"
                />
                <button
                  className={`w-32 py-3 rounded-lg text-xs ${
                    show60
                      ? "bg-neutral-700 text-neutral-400"
                      : "bg-primary text-black"
                  }`}
                  onClick={() => {
                    if (show60) {
                      return;
                    }
                    const data = { ...sendData };
                    if (data.type === 1) {
                      data.area = area?.internationalAreaCode;
                    }
                    sendSMS(data);
                  }}
                >
                  {!show60 && translate(getText("發送驗證碼"))}
                  {show60 && `${time}s`}
                </button>
              </div>

              <div className="relative">
                <input
                  type={passwordType3 ? "password" : "text"}
                  name="password"
                  value={sendData.password}
                  placeholder={translate(getText("請輸入密碼"))}
                  onChange={updateSendData}
                  className="w-full bg-neutral-800 border border-neutral-700 rounded-lg px-4 py-3 text-sm text-white focus:outline-none focus:border-primary"
                />
                <div
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                  onClick={() => {
                    setPasswordType3(!passwordType3);
                  }}
                >
                  <img
                    src={
                      passwordType3
                        ? "/img/login_btn_eye_close.png"
                        : "/img/login_btn_eye_open.png"
                    }
                    className="w-5 h-5"
                  />
                </div>
              </div>

              <div className="relative">
                <input
                  type={passwordType4 ? "password" : "text"}
                  name="repassword"
                  value={sendData.repassword}
                  placeholder={translate(getText("請輸入密碼"))}
                  onChange={updateSendData}
                  className="w-full bg-neutral-800 border border-neutral-700 rounded-lg px-4 py-3 text-sm text-white focus:outline-none focus:border-primary"
                />
                <div
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                  onClick={() => {
                    setPasswordType4(!passwordType4);
                  }}
                >
                  <img
                    src={
                      passwordType4
                        ? "/img/login_btn_eye_close.png"
                        : "/img/login_btn_eye_open.png"
                    }
                    className="w-5 h-5"
                  />
                </div>
              </div>

              {inviteType == "1" && (
                <div className="relative">
                  <input
                    type="text"
                    name="invit"
                    value={sendData.invit}
                    placeholder={translate(getText("請輸入邀請碼"))}
                    onChange={updateSendData}
                    className="w-full bg-neutral-800 border border-neutral-700 rounded-lg px-4 py-3 text-sm text-white focus:outline-none focus:border-primary"
                  />
                </div>
              )}
            </div>
          )}

          {/* Submit Buttons and Message */}
          <div className="mt-6">
            {registerMsg && (
              <div className="text-center text-sm text-danger mb-4">
                {registerMsg}
              </div>
            )}

            <button
              className="w-full bg-gradient-primary text-black py-3 rounded-lg font-medium mb-4 transition-all hover:opacity-90 active:scale-98"
              onClick={() => {
                const data = { ...sendData };
                if (data.type === 1) {
                  data.area = area?.internationalAreaCode;
                }
                doRegister(data);
              }}
            >
              {translate(getText("立即註冊"))}
            </button>

            <div className="flex justify-between items-center text-sm">
              <button
                className="text-primary"
                onClick={() => {
                  navigate("/login");
                }}
              >
                {translate(getText("登錄"))}
              </button>

              {appStatus === "1" && (
                <button
                  className="text-primary"
                  onClick={() => {
                    navigate("/download");
                  }}
                >
                  App{(lan == "zh" ? "" : " ") + translate(getText("下載"))}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
